import { FC, useContext } from 'react';

import { Paragraph, H3 } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './TooltipScreenshots.module.scss';

export const TooltipScreenshots: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.tooltip}>
      <H3 className={s.tooltip_title}>{t('application.screen')}</H3>
      <ul className={s.tooltip_list}>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('application.image.minRes')}
          </span>
          <span className={s.tooltip_size}>640x360</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('goods.edit.photo.optimalRes')}
          </span>
          <span className={s.tooltip_size}>1280x720</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>{t('application.image.sides')}</span>
          <span className={s.tooltip_size}>16:9</span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>{t('size')}</span>
          <span className={s.tooltip_size}>
            {t('application.screen.tooltip.size')}
          </span>
        </li>
        <li className={s.tooltip_item}>
          <span className={s.tooltip_info}>
            {t('application.image.format')}
          </span>
          <span className={s.tooltip_size}>.jpeg</span>
        </li>
      </ul>
      <Paragraph size={'s'} color="secondary" className={s.tooltip__text}>
        {t('application.game.image.size.help')}
      </Paragraph>
    </div>
  );
};
